import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../services/firebase";
import WineCard from "../components/WineCard";

export default function TypePage() {
  const { type: rawType } = useParams();
  const type = decodeURIComponent(rawType || "");

  const [wines, setWines] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function run() {
      if (!type) return;
      setLoading(true);
      try {
        const winesCol = collection(db, "winesek");
        const q = query(winesCol, where("type", "==", type));
        const snap = await getDocs(q);
        const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        setWines(list);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    }
    run();
  }, [type]);

  return (
    <div className="container py-4">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h1 className="h4 m-0 text-uppercase">Type : {type}</h1>
        <Link to="/" className="btn btn-sm btn-outline-dark">
          ← Accueil
        </Link>
      </div>

      {loading ? (
        <p>Chargement…</p>
      ) : wines.length === 0 ? (
        <div className="text-muted">Aucun vin trouvé pour ce type.</div>
      ) : (
        <div className="row">
          {wines.map((wine) => (
            <div key={wine.id} className="col-6 col-md-4 col-lg-3 mb-4">
              <WineCard wine={wine} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
